let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("3oRux")).then(() => parcelRequire('EGJr4'));